import { AppLink } from '@/lib/appLink';

/**
 * Accessible breadcrumb navigation (visual + pairs with BreadcrumbList JSON-LD).
 *
 * @param {{
 *   items: Array<{ label: string, href: string }>,
 *   variant?: 'hero' | 'default',
 * }} props
 */
export default function BreadcrumbNav({ items, variant = 'default' }) {
  if (!items?.length) return null;

  const isHero = variant === 'hero';

  return (
    <nav
      aria-label="Breadcrumb"
      className={`grv-breadcrumb ${isHero ? 'grv-breadcrumb--hero' : 'grv-breadcrumb--default'}`}
    >
      <ol className="grv-breadcrumb__list">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const href = item.href || '/';

          return (
            <li key={`${item.label}-${href}-${index}`} className="grv-breadcrumb__item">
              {isLast ? (
                <span className="grv-breadcrumb__current" aria-current="page">
                  {item.label}
                </span>
              ) : (
                <AppLink href={href} className="grv-breadcrumb__link">
                  {item.label}
                </AppLink>
              )}
              {!isLast ? <span className="grv-breadcrumb__sep" aria-hidden="true">/</span> : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
